import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, setPaginaAtual, getList } from './erroActions';

import List from './erroList';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';

class ControladorErro extends Component {
  componentWillMount() {
    this.props.init();
  }

  changeControlador = () => {
    this.props.setPaginaAtual(0);
    setTimeout(() => {
      this.props.getList();
    }, 100);
  };

  render() {
    const selectStyle = {
      height: '38px',
      padding: '7px 10px',
      fontSize: '13px',
      fontWeight: '500',
      border: '1px solid #bfd0e0',
      borderRadius: '10px',
      backgroundColor: '#ffffff',
      color: '#475569',
      boxShadow: 'none',
    };

    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <div
                style={{
                  marginLeft: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  padding: '4px 12px 4px 0',
                  justifyContent: 'flex-end',
                  minWidth: 'max-content',
                }}
              >
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  >
                    Grupo Físico:
                  </label>
                  <SelectConfGrupoFisico
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{ ...selectStyle, width: '180px' }}
                  />
                </div>
                <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                  <label
                    style={{
                      fontSize: '13px',
                      color: '#475569',
                      fontWeight: '600',
                      margin: 0,
                      paddingRight: '4px',
                    }}
                  />
                  <SelectConfControlador
                    anel={false}
                    onChange={this.changeControlador}
                    emptyText="Todos"
                    customStyle={{ ...selectStyle, width: '260px' }}
                  />
                </div>
              </div>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, setPaginaAtual, getList }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(ControladorErro);
